import * as ng from 'angular';

import * as elementResizeDetectorMaker from 'element-resize-detector';

ng.module('e360')
   .directive('nvClassExpr', nvClassExprDirective);

/**
 * Simple alternative to ngClass that adds $width and $height properties
 * to an issolated scope for use in expressions.
 */
export function nvClassExprDirective():ng.IDirective {
   return {
      restrict: 'A',
      scope: { },
      link: nvClassExprLinkFn
   };
}

interface Scope extends ng.IScope {
   $width:number;
   $height:number;
}

function nvClassExprLinkFn(scope:Scope, element:ng.IAugmentedJQuery, attr) {
   // scroll strategy doesn't work when this directive is inside tab
   let erd = elementResizeDetectorMaker({strategy: 'object'});
   erd.listenTo(element, sizeUpdate);

   scope.$watch(attr.nvClassExpr, nvClassExprWatchAction);

   scope.$on('$destroy', () => erd.removeAllListeners(element));

   function sizeUpdate() {
      // use $apply so that angular runs the $watch after size updates
      scope.$apply(() => {
         scope.$width = element.width();
         scope.$height = element.height();
      });
   }

   function nvClassExprWatchAction(newClasses, oldClasses) {
      ng.forEach(newClasses, (cond, cls:string) => {
         if (cond) {
            element.addClass(cls);
         } else {
            element.removeClass(cls);
         }
      });
   }
}
